import styled from '@emotion/styled'

const DefaultReactModalStyleContainer = styled.div`
    width: min-content;
    height: min-content;
    margin: auto;

    border-radius: 13px !important;

    box-shadow: 0 0 31px -3px rgba(179, 179, 179, 0.66);
    -webkit-box-shadow: 0 0 31px -3px rgba(179, 179, 179, 0.66);
    -moz-box-shadow: 0 0 31px -3px rgba(179, 179, 179, 0.66);

    .modal-close-button {
        float: right;
        margin: 0.5rem;

        img {
            height: 1rem;
            width: 1rem;
        }
    }
`

export { DefaultReactModalStyleContainer }
